import React from 'react';
import { Common } from 'ws-scripts/modules/common';

import { DAYS_OF_WEEK } from '../date-constants';
import propDefs from '../proptypes';

const getCurrentDayName = () => {
	// We shift the array by one, since our week starts at Monday.
	const dayIndex =
		(new Date().getDay() + DAYS_OF_WEEK.length - 1) % DAYS_OF_WEEK.length;
	return DAYS_OF_WEEK[dayIndex];
};

const isCurrentDay = (day, dayName, shrinkIdenticalHours) => {
	const currentDayName = getCurrentDayName();

	if (shrinkIdenticalHours === 'true' && Array.isArray(dayName)) {
		const startDayIndex = DAYS_OF_WEEK.indexOf(dayName[0]);
		const endDayIndex = DAYS_OF_WEEK.indexOf(dayName[1]);
		const currentDayIndex = DAYS_OF_WEEK.indexOf(currentDayName);

		if (
			currentDayIndex >= startDayIndex &&
			currentDayIndex <= endDayIndex
		) {
			return true;
		}
	} else if (currentDayName === day) {
		return true;
	}

	return false;
};

class HoursListItem extends React.Component {
	constructor(props) {
		super(props);
		this.renderDelegate = this.renderDelegate.bind(this);
		this.state = {
			isClient: false
		};
	}

	componentDidMount() {
		/* We intentionally force a re-render here to update the
		 * highlighted day according to the client's timezone. */
		// eslint-disable-next-line react/no-did-mount-set-state
		this.setState((_state, _props) => {
			return {
				isClient: true
			};
		});
	}

	renderDelegate({ prefs, labels }) {
		const { hours } = this.props;
		let dayName = hours.day.includes(' - ')
			? hours.day.split(' - ')
			: hours.day;
		let wrapperClass = [];
		const classColDay = ['key'];
		const classColHour = ['value'];

		if (
			this.state.isClient &&
			isCurrentDay(hours.day, dayName, prefs.shrinkIdenticalHours)
		) {
			wrapperClass.push('today');
		}

		if (Array.isArray(dayName)) {
			dayName = dayName
				.map(day => labels.get(day.toUpperCase()))
				.join(' - ');
		} else {
			dayName = labels.get(dayName.toUpperCase());
		}

		const timingsLabel = hours.timings.trim().toUpperCase();
		const dayTimings = labels.has(timingsLabel)
			? labels.get(timingsLabel)
			: hours.timings;

		let justifyClass = '';
		switch (prefs.hoursTextAlignment) {
			case 'right':
				justifyClass = 'text-right';
				break;
			case 'center':
				justifyClass = 'text-center';
				break;
			case 'left':
				justifyClass = 'text-left';
				break;
			default:
				justifyClass = '';
		}

		if (
			prefs.showCurrentDayOnly === 'true' &&
			!isCurrentDay(hours.day, dayName, prefs.shrinkIdenticalHours) &&
			!this.props.isModal
		) {
			return null;
		}

		if (prefs.showCurrentDayOnly === 'true' && !this.props.isModal) {
			dayName = `${labels.get('TODAYS_HOURS')}: `;
			wrapperClass = ['col-md-5 col-lg-4 col-xs-12'];
		} else {
			classColDay.push('col-md-5 col-xs-6');
			classColHour.push('col-md-7 col-xs-6');
			wrapperClass.push('py-2 row');
		}

		return (
			<li className={wrapperClass.join(' ')}>
				<span className={classColDay.join(' ')}>{dayName}</span>
				<span className={`${classColHour.join(' ')} ${justifyClass}`}>
					{dayTimings}
				</span>
			</li>
		);
	}

	render() {
		return <Common render={this.renderDelegate} />;
	}
}

HoursListItem.defaultProps = {
	hours: propDefs.defaults.hours,
	isModal: propDefs.defaults.isModal
};

HoursListItem.propTypes = {
	hours: propDefs.hoursEntry,
	isModal: propDefs.settings.isModal
};

export default HoursListItem;



// WEBPACK FOOTER //
// ./src/components/HoursListItem.jsx